export default __webpack_public_path__ + "static/media/icon4.df79c7a2.png";